import { JSX, useCallback } from 'react'

import { Input } from 'core-components/library/inputs'

import { IRenderCustomSettingsParams } from '../flexItem/models/IRenderCustomContent'
import { BasicSettingsLibrary, BasicSettingsStatic, getPropertiesByType } from '../settings'
import settingsStyle from '../settings/SettingsStyles.module.scss'

export type TRenderWidgetSettingsByType = (
  params: IRenderCustomSettingsParams
) => JSX.Element | null

export const useRenderCustomSettingsWidget = (
  renderWidgetSettings?: TRenderWidgetSettingsByType
) => {
  const renderCustomSettingsWidget = useCallback(
    (params: IRenderCustomSettingsParams) => {
      const { widget, onChangeField, tab } = params
      const renderCustomWidgetSettings = (defaultValue: JSX.Element | null) => {
        return (renderWidgetSettings && renderWidgetSettings(params)) || defaultValue
      }
      if (widget.type === 'Iframe') {
        return renderCustomWidgetSettings(
          <Input
            classes={{ root: settingsStyle.lineElement }}
            label="External URL"
            value={widget.src}
            onChange={(value: string) => onChangeField('src', value)}
          />
        )
      }

      if (tab === 'baseSettings' && (widget.type === 'Static' || widget.type === 'RemoteStatic')) {
        return renderCustomWidgetSettings(
          <BasicSettingsStatic widget={widget} onChangeField={onChangeField} tab={tab} />
        )
      }

      if (widget.type === 'FromLibrary') {
        return renderCustomWidgetSettings(
          <BasicSettingsLibrary
            widget={widget}
            onChangeField={onChangeField}
            tab={tab}
            getPropertiesByType={getPropertiesByType}
          />
        )
      }

      return null
    },
    [renderWidgetSettings]
  )

  return { renderCustomSettingsWidget }
}
